import React, { useState,useEffect } from "react";
import "./SignupPage.css";
import { FaUser, FaEnvelope, FaPhone, FaLock ,FaEye, FaEyeSlash} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import API from "../utils/axiosInstance";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";   // ✅ Import i18n
import LanguageTranslation from "../components/languageTranslation"; // ✅ Import your language switcher
import i18n from "../../src/config/i18n"; // ✅ Import i18n for language direction



const SignupPage = ({ lang }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { t } = useTranslation(); // ✅ initialize translation


  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    try {
      const response = await API.post("/users/register", {
        name,
        email,
        phone,
        password,
      });

      toast.success("Signup successful!", {
        position: "top-right",
        autoClose: 2000,
      });

      setTimeout(() => {
        navigate("/");
      }, 2200);
    } catch (err) {
      console.error("Signup error:", err);
      toast.error(err.response?.data?.message || "Signup failed", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

    useEffect(() => {
    if (lang) i18n.changeLanguage(lang); // force the correct language
  }, [lang, i18n]);

  return (
    <div className="page-wrapper">

      <div className="top-bar">
      <img src="/logo.svg" alt="Logo" className="logo-bar" />
      <LanguageTranslation className="lang-dropdown" /> {/* ✅ Added Dropdown */}

    </div>
      <div className="signup-container">
        {/* Toast Container */}
        <ToastContainer />

        <div className="signup-form">
          {/* <img src="/logo.svg" alt="Logo" className="logo" /> */}
          <h2>{t("CreateAccount")} </h2>

          <form onSubmit={handleSignup}>
            <div className="input-group">
              <FaUser className="input-icon" />
              <input
                type="text"
                placeholder={t("FullName")}
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                placeholder={t("EnterEmail")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <FaPhone className="input-icon" />
              <input
                type="tel"
                placeholder={t("PhoneNumber")}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </div>

           <div className="input-group">
  <FaLock className="input-icon" />
  <input
    type={showPassword ? "text" : "password"}
    placeholder={t("EnterPassword")}
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    required
  />
  <span
    className="toggle-password"
    onClick={() => setShowPassword(!showPassword)}
  >
    {showPassword ? <FaEyeSlash /> : <FaEye />}
  </span>
</div>

          <div className="input-group">
  <FaLock className="input-icon" />
  <input
    type={showConfirmPassword ? "text" : "password"}
    placeholder={t("ConfirmPassword")}
    value={confirmPassword}
    onChange={(e) => setConfirmPassword(e.target.value)}
    required
  />
  <span
    className="toggle-password"
    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
  >
    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
  </span>
</div>


            <button type="submit" className="signup-btn">{t("SignUp")}</button>
          </form>

          <p className="login-link">
            {t("AlreadyHaveAccount")}{" "}
            <Link to="/
        " className="signin-link">{t("SignIn")}</Link>
          </p>
        </div>

        
      </div>
    </div>
  );
};

export default SignupPage;
